import { getBrandIdFromUri } from './Brand';

// Loads the configuration for the *current* tenant from the BFF and injects it
// into `window.env.REACT_APP_TENANTS` (the shape the rest of the app expects).
//
// Why this is client-side: behind Cloudflare/Envoy the original public host
// (e.g. "compensa-lv.dev.opti-crop.com") is stripped before any server sees it,
// so the tenant cannot be resolved server-side. The browser, however, always
// knows its own host. We resolve the tenant id from the host here (via the
// brand regex already present in window.env) and ask the BFF for just that one
// tenant - we never download the full tenant list.
const loadCurrentTenant = async (): Promise<void> => {
  // Local dev (and any SSI-injected setup) already provides the tenants
  // directly in window.env, so there is nothing to fetch.
  if (window.env.REACT_APP_TENANTS) {
    return;
  }

  const id = getBrandIdFromUri();
  const base = window.env.REACT_APP_GRAPHQL_URI || '/';
  const requestUrl = `${base}api/tenants/${encodeURIComponent(id)}`;

  try {
    const response = await fetch(requestUrl, { credentials: 'include' });

    if (!response.ok) {
      throw new Error(`tenant request failed with status ${response.status}`);
    }

    const tenant = await response.json();
    window.env.REACT_APP_TENANTS = JSON.stringify([tenant]);
  } catch (e) {
    // Leave REACT_APP_TENANTS unset - getBrandList() then throws a clear error
    // and the app renders its error screen instead of silently misbehaving.
    // tslint:disable-next-line:no-console
    console.error('Failed to load tenant configuration', e);
  }
};

export default loadCurrentTenant;
